import _ from 'lodash-es';
import kformBuilderUtils from '../utils/kform-builder.utils';
import template from './value-builder-with-shortcuts.html';

const valueBuilderWithShortcutsDirective = /* @ngInject */ () => ({
	scope: {
		form: '=',
		component: '=',
		data: '=',
		label: '@',
		tooltipText: '@',
		valueLabel: '@',
		labelLabel: '@',
		valueProperty: '@',
		labelProperty: '@',
	},
	restrict: 'E',
	template,
	replace: true,
	/**
	 * @param {any} $scope
	 * @param {any} element
	 * @param {any} attributes
	 */
	link($scope, element, attributes) {
		const shortcuts = kformBuilderUtils.getAvailableShortcuts($scope.form, $scope.component);

		/**
		 * @param {any} entries
		 */
		const updateShortcuts = entries => {
			/** @type {any[]} */
			const bindedShortcuts = [];
			for (const entry of entries) {
				if (entry.shortcut) {
					bindedShortcuts.push(entry.shortcut);
				}
			}
			$scope.shortcuts = entries.map((/** @type {any} */ entry) => {
				const shortcutsToOmit = _.without(bindedShortcuts, entry.shortcut);
				return _.difference(shortcuts, shortcutsToOmit);
			});
		};

		$scope.valueProperty = $scope.valueProperty || 'value';
		$scope.labelProperty = $scope.labelProperty || 'label';
		$scope.valueLabel = $scope.valueLabel || 'Value';
		$scope.labelLabel = $scope.labelLabel || 'Label';

		$scope.shortcuts = [];

		$scope.data = $scope.data || [];

		if ($scope.data.length > 0) {
			updateShortcuts($scope.data);
		}

		$scope.addValue = () => {
			/** @type {any} */
			const object = {};
			object[$scope.valueProperty] = '';
			object[$scope.labelProperty] = '';
			object.shortcut = '';
			$scope.data.push(object);
		};

		$scope.removeValue = (/** @type {number} */ index) => {
			$scope.data.splice(index, 1);
		};

		if ($scope.data.length === 0) {
			$scope.addValue();
		}

		if (!attributes.noAutocompleteValue) {
			$scope.$watch('data', (/** @type {any} */ newValue, /** @type {any} */ oldValue) => {
				if (newValue.length !== oldValue.length) {
					updateShortcuts(newValue);
					return;
				}

				let shortcutChanged = false;
				_.map(newValue, (entry, index) => {
					const oldEntry = oldValue[index];

					if (entry.shortcut !== oldEntry.shortcut) {
						shortcutChanged = true;
					}

					if (
						entry[$scope.labelProperty] !== oldEntry[$scope.labelProperty] // label changed
						&& (
							entry[$scope.valueProperty] === ''
							|| entry[$scope.valueProperty] === _.camelCase(oldEntry[$scope.labelProperty])
						)
					) {
						entry[$scope.valueProperty] = _.camelCase(entry[$scope.labelProperty]);
					}
				});

				if (shortcutChanged) {
					updateShortcuts(newValue);
				}
			}, true);
		}
	},
});

export default valueBuilderWithShortcutsDirective;
